<template>
  <div>
<!--    <el-input type="hidden"-->
<!--              v-model="inputvalues22"-->
<!--              ref="inputvalues22input"></el-input>-->
    <el-row :gutter="11"
            style="height:20px;">
      <el-col :span="20" v-show="(inputvalues.length > 0)">
        <span>必修项</span>
      </el-col>
<!--        <el-col :span="15">-->
<!--            <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span>-->
<!--        </el-col>-->
    </el-row>
    <div v-show="(inputvalues.length > 0)">
      <el-table ref="tbl"
                :key='tableKey'
                :data="inputvalues"
                v-loading.body="listLoading"
                :cell-style="cellStylec"
                :show-header="false"
                style="width: 100%;text-align: left;"
                border
                stripe
                empty-text=" " v-show="(inputvalues.length > 0)">
          <el-table-column label="coursecode"
                           prop="courseName"
                           min-width="100px"
                           width="400px"
                           align="center">
              <template slot-scope="sc"
                        style="width: 130px; float: left;">

                  <div>
                      {{sc.row.courseName}}({{ sc.row.courseCode }})
                  </div>
                  <!-- <span @click.native="showView(sc)">{{sc.row.offeringNo}}</span> -->
              </template>
          </el-table-column>
          <!--学习对象类型-->
          <el-table-column label="coursecode"
                           prop="learningObjectNameCn"
                           min-width="80px"
                           align="center">
          </el-table-column>
          <!--要求完成状态  width="400px"-->
          <el-table-column label="coursecode"
                           prop="conditionCompleteStatusName"
                           min-width="90px"

                           align="center">
          </el-table-column>

      </el-table>
    </div>
  </div>
</template>
<script>

export default {

  name: 'condition',
  props: {
    // 设置列表文本框是否显示
    // inputvaluestrue22: Number,
    inputvalues: Array, // String, // 父的子内容
    // inputvalues22: String, // String, // 父的选项
  },
  data () {
    return {
      infiledList: [],
      input: '',
      dialogTableVisible: false,
      val: 'test',
      courselst: [],
      cnt: 0,
      listLoading: '',
      tableKey: '',
    }
  },
  methods: {
    cellStylec ({ row, column, rowIndex, columnIndex }) {
      return {
        background: '#fff'
      }
    }
  }
}
</script>
<style lang='scss' scoped>
    /*.el-input {*/
    /*    position: relative;*/
    /*    font-size: 14px;*/
    /*    display: inline;*/
    /*    !* display: inline-block; inline*!*/
    /*    width: 100%;*/
    /*}*/
    .el-table >>> td {
        padding: 1px;
        padding-left: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
    }
    .el-table >>> th {
        padding: 1px;
        padding-left: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
    }
</style>
